import { Component } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { KeycloakProfile } from 'keycloak-js';
import { environment } from 'src/environments/environment';
import { Constants } from '../common/constants';
import { LoaderService } from '../common/loader-service';
import { LocalStorage } from '../common/local-storage';
import { Tags } from '../common/tags';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import { HttpUtils } from '../common/http-utils';
import { Toast } from '../common/toast';
import { GUI } from '../common/gui';
import { Utils } from '../common/utils';
import { LocationStrategy } from '@angular/common';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent {

  public isLoggedIn = false;

  private userProfile: KeycloakProfile | null = null;

  private loaderTaskId: string = 'LOGIN_';

  constructor(private location: LocationStrategy, private readonly keycloakService: KeycloakService, private utils: Utils, public constants: Constants, private localStorage: LocalStorage, private tags: Tags,
    private loaderService: LoaderService, private toast: Toast, private httpUtils: HttpUtils, private gui: GUI) {
    history.pushState(null, null, window.location.href);
    this.location.onPopState(() => {
      history.pushState(null, null, window.location.href);
    });

    this.localStorage.removeStorageKey(this.tags.EMAIL_VERIFICATION_STATUS);

    const currentBuildDate = this.localStorage.getStorageKey(this.tags.PROJECT_BUILD_DATE);
    const latestBuildDate = environment.buildDate;
    // console.log("Current build date stored in storage is ", currentBuildDate, "Latest build date is ", latestBuildDate);

    this.loaderService.startLoaderV2(this.loaderTaskId + '1');
  }

  public async ngOnInit() {
    this.isLoggedIn = await this.keycloakService.isLoggedIn();
    if (this.isLoggedIn == true) {
      // Cookie.set(this.tags.KEYCLOAK_TOKEN, this.keycloakService.getKeycloakInstance().token, 1, environment.path, environment.domain);
      // Cookie.set(this.tags.KEYCLOAK_REFRESH_TOKEN, this.keycloakService.getKeycloakInstance().refreshToken, 1, environment.path, environment.domain);
      this.localStorage.setMemoryKey(this.tags.KEYCLOAK_TOKEN, this.keycloakService.getKeycloakInstance().token);
      this.localStorage.setMemoryKey(this.tags.KEYCLOAK_REFRESH_TOKEN, this.keycloakService.getKeycloakInstance().refreshToken);
      this.userProfile = await this.keycloakService.loadUserProfile();
      const userId = this.keycloakService.getKeycloakInstance().refreshTokenParsed?.sub;


      this.fetchServerToken(userId);
    } else {
      this.loaderService.stopLoaderV2(this.loaderTaskId + '1');
    }

    // console.log(first)
  }

  private fetchServerToken(userId: string): void {
    this.httpUtils.fetchServerToken().then(serverResponse => {
      if (serverResponse.responseCode === this.constants.STATUS_SUCCESS) {
        this.localStorage.setMemoryKey(this.tags.APPLICATION_TOKEN, serverResponse.bearerToken);
        this.saveLoginDetails(userId);
      } else {
        this.toast.showErrorToast(serverResponse.responseMsg);
        this.loaderService.stopLoaderV2(this.loaderTaskId + '1');
        this.gui.openLogoutPage();
      }
    });
  }

  private saveLoginDetails(userId: string) {
    this.httpUtils.saveLoginDetails(userId, this.userProfile.email, this.userProfile.username, this.userProfile.firstName, this.userProfile.lastName).then(serverResponse => {
      this.loaderService.stopLoaderV2(this.loaderTaskId + '1');
      if (serverResponse.responseCode === this.constants.STATUS_SUCCESS) {
        const loggedUserId = this.utils.encryptString(serverResponse.userId);
        const loggedUserFullName = this.utils.encryptString(serverResponse.userFullName);

        this.localStorage.setMemoryKey(this.tags.LOGGED_USER_ID, loggedUserId);
        this.localStorage.setMemoryKey(this.tags.LOGGED_USER_NAME, loggedUserFullName);
        this.gui.openDashboardPage();
      } else {
        this.toast.showErrorToast(serverResponse.responseMsg);
        this.gui.openLogoutPage();
      }
    });
  }

  doLogin() {
    this.keycloakService.login();
  }

}
